import { render, staticRenderFns } from "./IconLabelButton.vue?vue&type=template&id=e22a2b88&scoped=true"
import script from "./IconLabelButton.vue?vue&type=script&lang=js"
export * from "./IconLabelButton.vue?vue&type=script&lang=js"
import style0 from "./IconLabelButton.vue?vue&type=style&index=0&id=e22a2b88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e22a2b88",
  null
  
)

export default component.exports